export default "__VITE_ASSET__8gM6pK$S__"